export const entityType = {
	USER: "App\\Models\\User",
};
